export const SET_DEFAULT_VIEW = 'SET_DEFAULT_VIEW';
export const HANDLE_FLOW_ACTIONS = 'HANDLE_FLOW_ACTIONS';

export const REPLACE_ACCOUNT_VIEW = 'REPLACE_ACCOUNT_VIEW';
export const REPLACE_ACCOUNT_VIEWS = 'REPLACE_ACCOUNT_VIEWS';
export const UPDATE_VIEW_IN_STORE = 'UPDATE_VIEW_IN_STORE';
export const UPDATE_VIEW_AND_FLUSH_VIEW = 'UPDATE_VIEW_AND_FLUSH_VIEW';
export const FLUSH_VIEW_TO_FIREBASE = 'FLUSH_VIEW_TO_FIREBASE';
